/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState, useEffect } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import { Grid } from '@material-ui/core';
import { Form } from 'react-final-form';
import DialogTitle from '@mui/material/DialogTitle';
import { FormDialogProps } from './types';
import { FieldTextInput } from '../FieldTextInput';
import { LanguagesBar } from '../LanguagesBar';
import { PublishDates } from '../PublishDates';
import SnackbarMessage from '../SnackbarMessage/SnackbarMessage';
import strings from '../../resources/strings';
import './FormDialog.scss';
import { isString } from 'lodash';
import MultipleSelect from '../MultipleSelect/MultipleSelect';
import UserRoles from '../../resources/enums/UserRoles';

const FormDialog: React.FC<FormDialogProps> = (props) => {
    const [open, setOpen] = useState(false);
    const [error, setError] = useState(false);
    const [language, setLanguage] = useState('pl');
    const [datesVisible, setDatesVisible] = useState(false);
    const [componentData, setComponentData] = useState<any>();
    const [contactTypes, setContactTypes] = useState<{ value: string; label: string }[]>([]);

    const handleClickOpen = () => {
        setDatesVisible(false);
        setOpen(true);
        setComponentData(undefined);
    };

    const handleClose = () => {
        setError(false);
        setOpen(false);
    };

    const handleSubmit = (data: any) => {
        if (datesVisible && componentData && props.handleSubmit) {
            const componentDataWithDates = {
                ...componentData,
                publishFrom: new Date(data.publishFrom),
                publishTo: new Date(data.publishTo),
            };
            props.handleSubmit(componentDataWithDates, setOpen, setError);
        } else if (data.role?.includes(UserRoles.Coach) && props.buttonLabel == 'Add' && props.handleSubmit) {
            if (contactTypes.length <= 0) {
                setError(true);
                return;
            }
            data.contactTypes = contactTypes.map((x) => x.value);
            props.handleSubmit(componentData || data, setOpen, setError);
        } else if (props.handleSubmit) props.handleSubmit(componentData || data, setOpen, setError);
    };

    const showPublishDates = () => {
        if (props.publish) setDatesVisible(true);
    };

    const addLangSufix = (field: string, lang: string) => {
        return props.languages ? `${field}_${lang}` : field;
    };

    useEffect(() => {
        setError(false);
    }, []);
    return (
        <span>
            {props.button ? <props.button label={props.buttonLabel} action={handleClickOpen} /> : ''}
            <Dialog open={open} onClose={handleClose}>
                <Form
                    onSubmit={handleSubmit}
                    render={({ handleSubmit, form }) => {
                        return (
                            <form className="form-dialog" onSubmit={handleSubmit}>
                                {props.languages ? (
                                    <LanguagesBar
                                        languages={props.languages}
                                        selectedLanguage={language}
                                        handleChange={setLanguage}
                                    ></LanguagesBar>
                                ) : (
                                    ''
                                )}
                                {props.title ? (
                                    <DialogTitle
                                        className="form-dialog-header"
                                        style={{ fontWeight: 'bold', marginLeft: '2rem' }}
                                    >
                                        {props.title}
                                    </DialogTitle>
                                ) : (
                                    ''
                                )}

                                <DialogContent>
                                    <Grid container spacing={2} className="form-dialog-content">
                                        {props.textFields
                                            ? props.textFields.map((field) => {
                                                  return (
                                                      props.languages?.map((l) => {
                                                          return l.code;
                                                      }) || [language]
                                                  ).map((lang) => {
                                                      return (
                                                          <Grid
                                                              item
                                                              xs={12}
                                                              key={addLangSufix(field.id, lang)}
                                                              style={{
                                                                  display:
                                                                      language !== lang || field.hidden
                                                                          ? 'none'
                                                                          : 'block',
                                                              }}
                                                          >
                                                              <FieldTextInput
                                                                  variant={field.variant}
                                                                  required={field.required}
                                                                  name={addLangSufix(field.name, lang)}
                                                                  label={field.label}
                                                                  type={field.type}
                                                                  id={addLangSufix(field.id, lang)}
                                                                  select={field.select}
                                                                  data={field.data}
                                                                  autoFocus={field.autoFocus}
                                                                  hidden={field.hidden}
                                                                  defaultValue={
                                                                      isString(field.defaultValue)
                                                                          ? field.defaultValue
                                                                          : (
                                                                                field.defaultValue as Record<
                                                                                    string,
                                                                                    string
                                                                                >
                                                                            )?.[lang]
                                                                  }
                                                              />
                                                          </Grid>
                                                      );
                                                  });
                                              })
                                            : ''}
                                        {props.multipleOptions != null &&
                                        form.getState().values.role?.includes(UserRoles.Coach) ? (
                                            <>
                                                <MultipleSelect
                                                    options={props.multipleOptions}
                                                    setContactTypes={setContactTypes}
                                                    contactTypes={contactTypes}
                                                />
                                            </>
                                        ) : (
                                            ''
                                        )}
                                        {props.component?.item ? (
                                            props.languages ? (
                                                <props.component.item
                                                    languages={props.languages}
                                                    selectedLanguage={language}
                                                    data={
                                                        props?.component?.data
                                                            ? props.component?.filedName
                                                                ? props.component.data[props.component.filedName]
                                                                : props.component.data
                                                            : null
                                                    }
                                                    componentData={componentData}
                                                    setComponentData={setComponentData}
                                                />
                                            ) : (
                                                <props.component.item />
                                            )
                                        ) : (
                                            ''
                                        )}
                                        <PublishDates
                                            visibility={datesVisible}
                                            publishFrom={
                                                props?.component?.data
                                                    ? (props.component.data['publishFrom'] as Date)
                                                    : null
                                            }
                                            publishTo={
                                                props?.component?.data
                                                    ? (props.component.data['publishTo'] as Date)
                                                    : null
                                            }
                                        ></PublishDates>
                                        <SnackbarMessage
                                            serverity="error"
                                            message={error ? strings.languagesValidation.errorMessage : ''}
                                            clearMessage={() => {
                                                setError(false);
                                            }}
                                        ></SnackbarMessage>
                                    </Grid>
                                </DialogContent>
                                <Grid>
                                    {props.titleCourse ? (
                                        <DialogTitle
                                            className="form-dialog-header"
                                            style={{ fontWeight: 'bold', marginLeft: '2rem', paddingTop: '0' }}
                                        >
                                            {props.titleCourse}
                                        </DialogTitle>
                                    ) : (
                                        ''
                                    )}
                                </Grid>
                                <DialogActions>
                                    <Button
                                        type={props.leftBtnType || 'button'}
                                        onClick={() => {
                                            if (props.leftBtnType !== 'submit') handleClose();
                                        }}
                                    >
                                        {props.leftBtnName || 'Cancel'}
                                    </Button>
                                    <Button
                                        type={props.rightBtnType || 'submit'}
                                        onClick={showPublishDates}
                                        style={{ display: datesVisible ? 'none' : 'block' }}
                                    >
                                        {props.rightBtnName || 'Save'}
                                    </Button>
                                </DialogActions>
                            </form>
                        );
                    }}
                />
            </Dialog>
        </span>
    );
};

export default FormDialog;
